import { render, staticRenderFns } from "./OrderTable.vue?vue&type=template&id=29009b8a&scoped=true"
import script from "./OrderTable.vue?vue&type=script&lang=ts"
export * from "./OrderTable.vue?vue&type=script&lang=ts"
import style0 from "./OrderTable.vue?vue&type=style&index=0&id=29009b8a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29009b8a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Volumes/Untitled/project/185/185admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('29009b8a')) {
      api.createRecord('29009b8a', component.options)
    } else {
      api.reload('29009b8a', component.options)
    }
    module.hot.accept("./OrderTable.vue?vue&type=template&id=29009b8a&scoped=true", function () {
      api.rerender('29009b8a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/OrderTable.vue"
export default component.exports